import tinycolor from 'tinycolor2';

export default function getReadibilityColor(backgroundColor, { colors }) {
  const { light, dark } = colors;
  if (!backgroundColor) return dark.primary;
  return tinycolor
    .mostReadable(
      backgroundColor,
      [
        light.primary,
        light.stain,
        light.neutral,
        light.secondary,
        dark.primary,
        dark.stain,
        dark.neutral,
        dark.secondary
      ],
      { includeFallbackColors: true, level: 'AA', size: 'large' }
    )
    .toHexString();
}
